import { Chip } from "@material-ui/core";
import Translator from "Languages/Utility/Translator";
import React, { Fragment } from "react";

function StatusFormatter(cell, deactive = false) {
  return (
    <Fragment>
      <Chip
        className={deactive? 'deactive' : cell ? "success" : "danger"}
        label={
          cell ? <Translator id="active" /> : <Translator id="disable" />
        }
      />
    </Fragment>
  );
}

export default StatusFormatter;
